import styled from '@emotion/styled/macro';

// eslint-disable-next-line import/prefer-default-export
export const TrophyIconContainer = styled.div`
    margin-bottom: -55px;
    z-index: 1;
`;
